

























import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import { StudentData } from '@/mixins/requests/branch/StudentListApis.vue'

@Component({
  components: {
    ButtonBase,
  },
})
export default class StudentTable extends Vue {
  @Prop()
  private studentList!: StudentData[]

  @Prop()
  private onClickComfirmButton!: (bcbtCode: string) => void

  private buttonColortype(isPresenceStudied: boolean): string {
    return isPresenceStudied ? '' : 'pointer-events-none'
  }
}
